export default "__VITE_ASSET__DmXPg51F__"